import React, { useEffect, useState } from 'react';

// components
import { Row, Col, Nav, NavItem, NavLink, Button } from "reactstrap";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

// helpers
import { formateDateandTime } from "../../../helpers/formats.js";

// Views
import ModalEnderecoMapa from './ModalEnderecoMapa';
import EditarRespostaBoletim from './components/EditarRespostaBoletim';
import { getSessionCookie } from '../../../helpers/cookies.js';

export default function Inspecoes({ boletimVistoria, permitirEditarBoletim, setBoletimVistoria }) {
    const [stepFormulario, set_stepFormulario] = useState(0);

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    // state para guarda a questao que vai ser editado
    const [questaoEditar, setQuestaoEditar] = useState(null);

    const session = getSessionCookie();

    useEffect(() => {
        if (boletimVistoria && boletimVistoria.boletimVistoriaInspecoes.length > 0) {
            set_stepFormulario(boletimVistoria.boletimVistoriaInspecoes[0].boletimVistoriaInspecao_Id);
        }
    }, []);

    const [isOpenModalInspecao, set_isOpenModalInspecao] = useState(false);
    const [localizacaoInspecao, set_localizacaoInspecao] = useState(null)
    const handleOpenModalInspecao = (inspecao) => {
        set_isOpenModalInspecao(true);
        set_localizacaoInspecao([inspecao.geoLocalizacao.split(';')[0], inspecao.geoLocalizacao.split(';')[1]]);
    }

    return (
        <>
            <h5 className="subtitleCardInfo">Inspeções</h5>
            <Nav justified tabs pills className="mr-auto">
                {boletimVistoria.boletimVistoriaInspecoes.map((m, key) => (
                    <NavItem key={key}>
                        <NavLink
                            active={m.boletimVistoriaInspecao_Id == stepFormulario}
                            onClick={() => set_stepFormulario(m.boletimVistoriaInspecao_Id)}>
                            {m.local}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>
            {boletimVistoria.boletimVistoriaInspecoes.filter(f => f.boletimVistoriaInspecao_Id == stepFormulario).map((m, key) => (
                <>
                    <Row className="align-items-end">
                        <Col lg="8" md="8" sm="12" className="pb-2">
                            <strong>Endereço: </strong><span>{m.logradouro + ", " + m.bairro}</span>
                        </Col>
                        {m.geoLocalizacao &&
                            <Col lg="4" md="4" sm="12" className="pb-2 text-right">
                                <Button color="link" onClick={() => handleOpenModalInspecao(m)}><i className="fas fa-map"></i> Visualizar no Mapa</Button>
                            </Col>
                        }
                    </Row>
                    <Row className="align-items-end">
                        <Col lg="3" md="3" sm="12">
                            <strong>Início: </strong><span>{formateDateandTime(m.dataHoraInicio)}</span>
                        </Col>
                        <Col lg="3" md="3" sm="12">
                            <strong>Fim: </strong><span>{formateDateandTime(m.dataHoraFim)}</span>
                        </Col>
                    </Row>
                    <Row key={key} className="mt-4 mb-4">
                        {m.boletimVistoriaInspecaoFotos.map((foto, keyfoto) => (
                            <Col lg="3" md="6" sm="12" key={keyfoto} className="text-center mt-4">
                                <img src={foto.nomeArquivo.split('.').pop().toLowerCase() == "pdf" ? require("assets/img/document-ok.png") : foto.nomeArquivo} style={{ cursor: "pointer" }} width="40%" height="auto" onClick={() => window.open(foto.nomeArquivo, "_blank")} />
                            </Col>
                        ))}
                    </Row>
                    {/* Caso exista alguma questão para ser editada */}
                    {modal &&
                        <EditarRespostaBoletim
                            modalVisibilidade={modal}
                            setModalVisibilidade={toggle}
                            questaoEditar={questaoEditar}
                            setQuestaoEditar={setQuestaoEditar}
                            stepFormulario={stepFormulario}
                            boletimVistoria={boletimVistoria}
                            setBoletimVistoria={setBoletimVistoria}
                        />
                    }
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <TableContainer component={Paper}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align="left">Pergunta</StyledTableCell>
                                            <StyledTableCell align="left">Resposta</StyledTableCell>
                                            {boletimVistoria.situacaoAnalise != "Aguardando Análise" &&
                                                (session.perfil === "Gestor" || session.perfil === "Fiscal" || session.perfil === "Administrador") &&
                                                <StyledTableCell align="left">Valor Original</StyledTableCell>
                                            }
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {m.boletimVistoriaQuestoes.map((n, key2) => (
                                            <StyledTableRow key={key2}>
                                                <StyledTableCell align="left">{n.formularioVistoriaQuestao_Identificacao}</StyledTableCell>
                                                <StyledTableCell align="left">
                                                    {n.valor}
                                                    {permitirEditarBoletim &&
                                                        <button
                                                            className='ml-2 border-0 rounded-circle bg-transparent text-center'
                                                            onClick={() => {
                                                                setQuestaoEditar(n);
                                                                toggle();
                                                            }}
                                                        >
                                                            <i className='fas fa-pencil-alt' ></i>
                                                        </button>
                                                    }
                                                </StyledTableCell>
                                                {boletimVistoria.situacaoAnalise != "Aguardando Análise" &&
                                                    (session.perfil === "Gestor" || session.perfil === "Fiscal" || session.perfil === "Administrador") &&
                                                    <StyledTableCell align="left">{n.valorOriginal}</StyledTableCell>
                                                }
                                                <StyledTableCell component="th" scope="row">
                                                    {n.penalidade && <i className="fas fa-exclamation-circle text-danger"></i>}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Col>
                    </Row>
                    <hr />
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <label><i className="fas fa-exclamation-circle text-danger"></i> Respondido com inconformidade</label>
                        </Col>
                    </Row>
                    <ModalEnderecoMapa
                        isOpen={isOpenModalInspecao}
                        handleReturn={() => set_isOpenModalInspecao(false)}
                        position={localizacaoInspecao}
                    />
                </>
            ))}
        </>
    );
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontWeight: "bold",
        fontFamily: "Montserrat",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
    body: {
        fontFamily: "Montserrat",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);